import type { KeyValueStore } from '../../core/loglist/fetch';

/** localStorage when usable, else an in-memory stand-in (private mode, file://, tests). */
function pick(): KeyValueStore {
  try {
    const ls = globalThis.localStorage;
    const probe = '__ct_probe__';
    ls.setItem(probe, '1');
    ls.removeItem(probe);
    return ls;
  } catch {
    const m = new Map<string, string>();
    return {
      getItem: (k) => m.get(k) ?? null,
      setItem: (k, v) => void m.set(k, v),
      removeItem: (k) => void m.delete(k),
    };
  }
}

export const storage: KeyValueStore = pick();

export function readJson<T>(key: string, fallback: T): T {
  try {
    const raw = storage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : fallback;
  } catch {
    return fallback;
  }
}

export function writeJson(key: string, value: unknown): void {
  try {
    storage.setItem(key, JSON.stringify(value));
  } catch {
    /* quota or unavailable */
  }
}
